import { Injectable } from '@angular/core';
import { SpidUserDetails, UtenteDTO } from 'angular-portal-shell-app';
import { ConfigurationService } from '../../../configuration/configuration-service';
import { Utente } from '../../models/utente';

@Injectable({
	providedIn: 'root'
})
export class UtenteService {

	private utente: Utente;
	private userDetails: SpidUserDetails;

	constructor(
		private configurationService: ConfigurationService
	) {

		console.log('[UtenteService]');

		// console.log('[userProfile]', configurationService.userProfile);

		let utenteDTO = new UtenteDTO();

		utenteDTO = configurationService.userProfile;

		if (utenteDTO) {
			this.userDetails = utenteDTO.spidUserDetails;

			this.utente = new Utente(
				this.userDetails.fiscalNumber, this.userDetails.name,
				this.userDetails.familyName, this.userDetails.dateOfBirth,
				this.userDetails.email, this.userDetails.digitalAddress,
				this.userDetails.companyName, this.userDetails.ivaCode,
				utenteDTO.idPersonaFisica
				//TODO
				// utenteDTO.idPersonaFisica = "df2a6439-1439-4273-b1ec-2a3d8245faa5"
				// utenteDTO.idPersonaFisica = "978089b2-d63c-4274-8cee-de843110749a"
			);

		}
	}

	public getSpidUserDetails(): SpidUserDetails {
		return this.userDetails;
	}

	public getUtente(): Utente {
		return this.utente;
	}
}